export default __webpack_public_path__ + "static/media/back1.24b38449.svg";